import { Fragment, useState } from "react";
import { useOutletContext } from "react-router-dom";
import toast from "react-hot-toast";
import axios from "axios";
import Jazzicon, { jsNumberForAddress } from "react-jazzicon";
import { IconButton, Modal } from "@mui/material";
import { CircularProgress } from "@mui/material";

import { ReactComponent as PdfIcon } from "../../../assets/pdf.svg";

import { ModalStyle } from "../UploadKYC/style";

export default function CaseStatus() {
  const {
    allData: data,
    accountStatus,
    setAccountStatus,
    setAllErrors,
    handleClick,
    allErrors: errors,
    setAllErrors: setErrors,
    loading,
    setLoading,
  } = useOutletContext();
  const [openPreview, setOpenPreview] = useState(false);
  const handleClose = () => setOpenPreview(false);

  const PERSONAL_INFORMATION = [
    {
      label: "Name",
      value: `${data.personalInformation.first_name} ${data.personalInformation.last_name}`,
    },
    { label: "Email", value: data.personalInformation.email },
    { label: "Country", value: data.personalInformation.country },
    { label: "Street Address", value: data.personalInformation.street },
    { label: "Mobile", value: data.personalInformation.mobile },
    { label: "Zip Code", value: data.personalInformation.zip_code },
    { label: "City", value: data.personalInformation.city },
    { label: "Wallet Address", value: data.personalInformation.wallet_address },
  ];

  const handleSubmit = (event) => {
    event.preventDefault();

    if (errors.PersonalInformation) {
      return handleClick(0);
    } else if (errors.UploadKYC) {
      return handleClick(3);
    } else {
      setLoading(true);
      axios
        .post("register/account_status/sendAccountForApproval")
        .then(({ data }) => {
          toast.success(data.message);
          setErrors({
            KYC: "",
            personal_info: "",
          });
          setAllErrors({
            KYC: "",
            personal_info: "",
          });
          setAccountStatus("Pending");
          setLoading(false);
        })
        .catch(({ response }) => {
          toast.error(response.data.message);
          setLoading(false);
        });
    }
  };

  return (
    <div className="pb-5">
      <div className="pt-lg-0 pt-5 pb-15 d-flex justify-content-between align-items-center">
        <h3 className="mb-0 font-weight-bolder text-white font-size-h2 font-size-h1-lg">
          Account Summary
        </h3>
        {accountStatus === "Pending" && (
          <span className="label label-lg label-light-warning label-inline font-weight-bold py-4 px-10 py-5">
            Pending
          </span>
        )}
        {accountStatus === "Rejected" && (
          <span className="label label-lg label-light-danger label-inline font-weight-bold py-4 px-10 py-5">
            Rejected
          </span>
        )}
      </div>
      <form
        id="CaseStatus"
        onSubmit={handleSubmit}
        className={`row${loading ? " justify-content-center" : ""}`}
      >
        {loading ? (
          <CircularProgress />
        ) : (
          <>
            {accountStatus === "Pending" && (
              <div className="col-12">
                <div className="d-flex align-items-center bg-light-warning rounded p-5 mb-9 status-div just-dark">
                  <span className="svg-icon svg-icon-warning mr-5">
                    <span className="svg-icon svg-icon-lg">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="24px"
                        height="24px"
                        viewBox="0 0 24 24"
                        version="1.1"
                      >
                        <g
                          stroke="none"
                          stroke-width="1"
                          fill="none"
                          fill-rule="evenodd"
                        >
                          <rect x="0" y="0" width="24" height="24"></rect>
                          <path
                            d="M11.1669899,4.49941818 L2.82535718,19.5143571 C2.557144,19.9971408 2.7310878,20.6059441 3.21387153,20.8741573 C3.36242953,20.9566895 3.52957021,21 3.69951446,21 L21.2169432,21 C21.7692279,21 22.2169432,20.5522847 22.2169432,20 C22.2169432,19.8159952 22.1661743,19.6355579 22.070225,19.47855 L12.894429,4.4636111 C12.6064401,3.99235656 11.9909517,3.84379039 11.5196972,4.13177928 C11.3723594,4.22181902 11.2508468,4.34847583 11.1669899,4.49941818 Z"
                            fill="#000000"
                            opacity="0.3"
                          ></path>
                          <rect
                            fill="#000000"
                            x="11"
                            y="9"
                            width="2"
                            height="7"
                            rx="1"
                          ></rect>
                          <rect
                            fill="#000000"
                            x="11"
                            y="17"
                            width="2"
                            height="2"
                            rx="1"
                          ></rect>
                        </g>
                      </svg>
                    </span>
                  </span>
                  <div className="d-flex flex-column flex-grow-1 mr-2">
                    <span
                      href="#"
                      className="text-warning py-1 font-size-lg font-size-status"
                    >
                      Pending
                    </span>
                    <p className="fw-bold d-block text-break">
                      Your application to join will be accepted after admin
                      confirmation. We will reply to you as soon as possible.
                      Thank you
                    </p>
                  </div>
                </div>
              </div>
            )}
            {errors.PersonalInformation && (
              <div className="col-12">
                <div className="d-flex align-items-center bg-light-danger rounded p-5 mb-9 status-div">
                  <span className="svg-icon svg-icon-danger mr-5">
                    <span className="svg-icon svg-icon-lg">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="24px"
                        height="24px"
                        viewBox="0 0 24 24"
                        version="1.1"
                      >
                        <g
                          stroke="none"
                          stroke-width="1"
                          fill="none"
                          fill-rule="evenodd"
                        >
                          <rect x="0" y="0" width="24" height="24"></rect>
                          <path
                            d="M11.1669899,4.49941818 L2.82535718,19.5143571 C2.557144,19.9971408 2.7310878,20.6059441 3.21387153,20.8741573 C3.36242953,20.9566895 3.52957021,21 3.69951446,21 L21.2169432,21 C21.7692279,21 22.2169432,20.5522847 22.2169432,20 C22.2169432,19.8159952 22.1661743,19.6355579 22.070225,19.47855 L12.894429,4.4636111 C12.6064401,3.99235656 11.9909517,3.84379039 11.5196972,4.13177928 C11.3723594,4.22181902 11.2508468,4.34847583 11.1669899,4.49941818 Z"
                            fill="#000000"
                            opacity="0.3"
                          ></path>
                          <rect
                            fill="#000000"
                            x="11"
                            y="9"
                            width="2"
                            height="7"
                            rx="1"
                          ></rect>
                          <rect
                            fill="#000000"
                            x="11"
                            y="17"
                            width="2"
                            height="2"
                            rx="1"
                          ></rect>
                        </g>
                      </svg>
                    </span>
                  </span>
                  <div className="d-flex flex-column flex-grow-1 mr-2">
                    <span className="text-danger py-1 font-size-lg font-size-status">
                      Personal Information
                    </span>
                    <p className="text-white fw-bold d-block text-break">
                      {errors.PersonalInformation.replace(/(\r\n|\n|\r)/gm, " ")
                        .split(" ")
                        .map((word, index) => (
                          <span key={index}>
                            {word}
                            <br />
                          </span>
                        ))}
                    </p>
                  </div>
                </div>
              </div>
            )}
            <div className="col-6">
              {PERSONAL_INFORMATION.slice(0, 4).map((information, index) => (
                <Fragment key={index}>
                  <h5 className="font-weight-bolder mb-3 text-white">
                    {information.label}:
                  </h5>
                  <div className="text-white-50 font-weight-bold line-height-lg mb-8">
                    <div>{information.value}</div>
                  </div>
                </Fragment>
              ))}
            </div>
            <div className="col-6">
              {PERSONAL_INFORMATION.filter(
                (info) => info.label !== "Wallet Address"
              )
                .slice(4)
                .map((information, index) => (
                  <Fragment key={index}>
                    <h5 className="font-weight-bolder mb-3 text-white">
                      {information.label}:
                    </h5>
                    <div className="text-white-50 font-weight-bold line-height-lg mb-8">
                      <div>{information.value}</div>
                    </div>
                  </Fragment>
                ))}

              <h5 className="font-weight-bolder text-white mb-3">
                Wallet Address:
              </h5>
              <div className="text-white-50 font-weight-bold line-height-lg mb-0">
                <div>
                  <div className="d-flex align-items-center">
                    <Jazzicon
                      diameter={20}
                      seed={jsNumberForAddress(data.linkWallet.wallet_address)}
                    />
                    <p className="ml-3 mb-0">
                      {`${data.linkWallet.wallet_address.slice(
                        0,
                        6
                      )}...${data.linkWallet.wallet_address.slice(
                        data.linkWallet.wallet_address.length - 4
                      )}`}
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-12 separator separator-dashed my-10"></div>
            {errors.UploadKYC && (
              <div className="col-12">
                <div className="d-flex align-items-center bg-light-danger rounded p-5 mb-9 status-div">
                  <span className="svg-icon svg-icon-danger mr-5">
                    <span className="svg-icon svg-icon-lg">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="24px"
                        height="24px"
                        viewBox="0 0 24 24"
                        version="1.1"
                      >
                        <g
                          stroke="none"
                          stroke-width="1"
                          fill="none"
                          fill-rule="evenodd"
                        >
                          <rect x="0" y="0" width="24" height="24"></rect>
                          <path
                            d="M11.1669899,4.49941818 L2.82535718,19.5143571 C2.557144,19.9971408 2.7310878,20.6059441 3.21387153,20.8741573 C3.36242953,20.9566895 3.52957021,21 3.69951446,21 L21.2169432,21 C21.7692279,21 22.2169432,20.5522847 22.2169432,20 C22.2169432,19.8159952 22.1661743,19.6355579 22.070225,19.47855 L12.894429,4.4636111 C12.6064401,3.99235656 11.9909517,3.84379039 11.5196972,4.13177928 C11.3723594,4.22181902 11.2508468,4.34847583 11.1669899,4.49941818 Z"
                            fill="#000000"
                            opacity="0.3"
                          ></path>
                          <rect
                            fill="#000000"
                            x="11"
                            y="9"
                            width="2"
                            height="7"
                            rx="1"
                          ></rect>
                          <rect
                            fill="#000000"
                            x="11"
                            y="17"
                            width="2"
                            height="2"
                            rx="1"
                          ></rect>
                        </g>
                      </svg>
                    </span>
                  </span>
                  <div className="d-flex flex-column flex-grow-1 mr-2">
                    <span
                      href="#"
                      className="text-danger py-1 font-size-lg font-size-status"
                    >
                      Know Your Customer
                    </span>
                    <p className="text-white fw-bold d-block text-break">
                      {errors.UploadKYC.replace(/(\r\n|\n|\r)/gm, " ")
                        .split(" ")
                        .map((word, index) => (
                          <span key={index}>
                            {word}
                            <br />
                          </span>
                        ))}
                    </p>
                  </div>
                </div>
              </div>
            )}
            <div className="col-12">
              <h5 className="font-weight-bolder text-white mb-3">KYC File:</h5>
              <div className="text-white-50 font-weight-bold line-height-lg mb-8">
                {openPreview && (
                  <Modal
                    aria-labelledby="image-preview"
                    aria-describedby="image-preview"
                    open={openPreview}
                    onClose={handleClose}
                  >
                    <ModalStyle onClick={handleClose}>
                      <img src={data.uploadKYC.kyc_file} alt="preview" />
                    </ModalStyle>
                  </Modal>
                )}
                {data.uploadKYC.type === "pdf" ? (
                  <IconButton
                    color="primary"
                    aria-label="upload kyc"
                    component="div"
                    className="image-preview-settings"
                    onClick={() => {
                      window.open(data.uploadKYC.kyc_file);
                    }}
                    sx={{
                      color: "#a01c1c",
                      width: "100px",
                      height: "100px",
                      marginBottom: "0.5rem",
                      svg: {
                        width: "80px",
                        height: "80px",
                      },
                    }}
                  >
                    <PdfIcon />
                  </IconButton>
                ) : (
                  <div className="image-preview-div">
                    <img
                      src={data.uploadKYC.kyc_file}
                      alt="preview"
                      onClick={() => setOpenPreview(true)}
                      style={{ cursor: "pointer", maxWidth: "120px" }}
                    />
                  </div>
                )}
              </div>
            </div>
          </>
        )}
      </form>
    </div>
  );
}
